export const Discord = "https://discord.gg/SsfKVG4HVk";
export const Telegram = "https://t.me/metagymland";
export const Twitter = "https://twitter.com/MetaGymLand";
export const TikTok = "https://www.tiktok.com/@metagymland";
export const Instagram = "https://www.instagram.com/metagymland";
export const Newsletter = "https://coderdidit.ck.page/666d446d94";
